<template>
  <div>
    <top-message />
    <div class="content">
      <div class="top">用户管理</div>
      <div class="from">
        <el-form ref="form" :model="form" :inline="true">
          <el-form-item label="登录账号">
            <el-input @change="search" v-model="form.loginName" clearable></el-input>
          </el-form-item>
          <el-form-item label="用户姓名">
            <el-input @change="search" v-model="form.name" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryInfo">查询</el-button>
            <el-button type="primary" @click="add">新增</el-button>
            <!-- <el-button icon="el-icon-upload2" @click="expertExcel">导出</el-button>
            <el-button icon="el-icon-upload2" @click="uploadExcel">批量上报</el-button>-->
          </el-form-item>
        </el-form>
      </div>
      <div class="tab">
        <el-table :data="applyProList" style="width: 100%">
          <el-table-column prop="loginName" label="登录账号" width="180">
            <template slot-scope="scope">{{scope.row.loginName}}</template>
          </el-table-column>
          <el-table-column prop="name" label="用户姓名">
            <template slot-scope="scope">{{scope.row.name}}</template>
          </el-table-column>
          <el-table-column prop="code" label="手机号">
            <template slot-scope="scope">{{scope.row.mobilePhone}}</template>
          </el-table-column>
          <el-table-column label="操作" width="170">
            <template slot-scope="scope"  >
              <div style="display: flex; width:100%; padding-right: 20px; justify-content: space-between;">
                <div
                  style="color: #2981EE;cursor: pointer;"
                  @click="view(scope.row)"
                >查看</div>
                <div
                  style="color: #2981EE;cursor: pointer;"
                  @click="deleteForm(scope.row)"
                >删除</div>
                <div
                  style="color: #2981EE;cursor: pointer;"
                  @click="updateForm(scope.row)"
                >修改</div>
            </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="this.form.pageSize"
            layout="total, prev, pager, next"
            :total="this.total"
          ></el-pagination>
        </div>
      </div>
      <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="600px"
        :close-on-click-modal = "false"
        :show-close="false"
        :modal-append-to-body="false"
      >
        <el-form
          ref="review"
          :model="registereFrom"
          :rules="reviewRule"
          label-width="100px"
        >
          <el-form-item
            label="登录账号:"
            prop="loginName"
          >
            <el-input
              v-model="registereFrom.loginName"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户姓名:"
            prop="name"
          >
            <el-input
              v-model="registereFrom.name"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="手机号:"
            prop="mobilePhone"
          >
            <el-input
              v-model="registereFrom.mobilePhone"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="密码:"
            prop="password"
            v-if="title != '查看'"
          >
            <el-input
              v-model="registereFrom.password"
            ></el-input>
          </el-form-item>
          <el-form-item prop="secondPassword" label="确认密码:"  v-if="title != '查看'">
            <el-input v-model="registereFrom.secondPassword" show-password></el-input>
          </el-form-item>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            v-if="title != '查看'"
            class="myMainButton"
            @click="dialogVisible = false"
          >取 消</el-button>
          <el-button
            v-if="title != '查看'"
            type="primary"
            class="myPrimaryButton"
            @click="handleSubmit('review')"
            :loading="submitLoading"
          >确 认</el-button>
          <el-button
            v-if="title == '查看'"
            type="primary"
            class="myMainButton"
            @click="dialogVisible = false"
            :loading="submitLoading"
          >关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import TopMessage from "@/components/TopMessage";
import { userInfoList, deleteUser, modUser } from "@/api/loglistinfo";
import { Register } from "@/api/login";
export default {
  components: { TopMessage },
  data() {
     var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    let validPassword = (rule, value, callback) => {
      let reg = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,20}$/;
      if (!reg.test(value)) {
        this.spanStatus = false;
        callback(new Error("密码必须是由6-16位字母+数字组合"));
      } else {
        this.spanStatus = true;
        callback();
      }
    };
    let secondPassword = (rule, value, callback) => {
      if (this.registereFrom.password == "") {
        callback(new Error("请先输入密码"));
      } else if (this.registereFrom.password !== "") {
        if (this.registereFrom.password == value) {
          callback();
        } else if (value == "") {
          callback(new Error("请输入确认密码"));
        } else if (this.registereFrom.password !== value) {
          callback(new Error("两次密码不一致"));
        }
      }
    };
    return {
      title:'新增',
      form: {
        loginName:'',
        name:'',
        page: 1,
        size: 10
      },
      submitLoading:false,
      registereFrom: {
        id:"",
        mobilePhone: "",
        name: "",
        password:'',
        loginName: "",
        secondPassword: "",
        sourceType:4
      },
      reviewRule: {
        name: [
          { required: true, message: "请输入用户姓名", trigger: "change" },
          { min: 1, max: 20, message: "长度在1到4个字", trigger: "change" }
        ],
        loginName: [{ required: true, message: '请输入登录账号', trigger: 'change' }],
        mobilePhone: [{ validator: checkPhone, required: true, trigger: "change" }],
        password: [{ validator: validPassword, required: true,  trigger: "change" }],
        secondPassword: [{ validator: secondPassword, required: true,  trigger: "change" }],
      },
      dialogVisible:false,
      applyProList: [],
      total: 0
    };
  },
  created() {
    this.getcheckinListList();
  },
  methods: {
    // 查询
    queryInfo() {
      this.form.page = 1
      this.getcheckinListList();
    },
    search() {
      this.getcheckinListList();
    },
    clearForm(){
      this.registereFrom={
        id:"",
        mobilePhone: "",
        name: "",
        password:'',
        loginName: "",
        secondPassword: "",
        sourceType:4
      }
    },
    handleSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(this.title == '新增'){
            Register(this.sendParam(this.registereFrom)).then(res => {
              let res1 = this.paramDecrypt(res);
              if (res1.code == 200) {
                this.dialogVisible = false;
                this.clearForm()
                this.$message.success(res1.msg);
                this.getcheckinListList()
              } else if (res1.code == 202) {
                this.$message.error(res1.msg);
              } else {
                this.$message.error(res1.msg);
              }
            });
          }else if(this.title == '修改'){
            modUser(this.sendParam(this.registereFrom)).then(res=>{
              let res1 = this.paramDecrypt(res);
              if (res1.code == 200) {
                this.dialogVisible = false;
                this.clearForm()
                this.$message.success(res1.msg);
                this.getcheckinListList()
              } else if (res1.code == 202) {
                this.$message.error(res1.msg);
              } else {
                this.$message.error(res1.msg);
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    async getcheckinListList() {
      const res = await userInfoList(this.form);
      this.applyProList = res.data.data.list;
      this.total = res.data.data.total;
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getcheckinListList();
    },
    view(row){
      this.title = '查看'
      this.registereFrom= {
        id:row.id,
        mobilePhone:row.mobilePhone,
        name:row.name,
        loginName:row.loginName,
        sourceType:4
      },
      this.dialogVisible = true
    },
    add(){
      this.title = '新增'
      this.clearForm()
      this.dialogVisible = true
      this.$refs.review.clearValidate();
    },
    updateForm(row){
      this.title = '修改'
      this.registereFrom= {
        id:row.id,
        mobilePhone:row.mobilePhone,
        name:row.name,
        loginName:row.loginName,
        password:'',
        secondPassword: "",
        sourceType:4
      },
      this.dialogVisible = true
    },
    deleteForm(row){
      deleteUser({id:row.id}).then(res=>{
        if (res.data.code === 200) {
          this.$message.success("删除成功")
          this.getcheckinListList();
        }else{
          this.$message.error(res.data.msg)
        }
      })
    }
    // expertExcel() {
    //   // if (this.form.applyTime[0] == undefined) {
    //   //   this.form.applyTime[0] = ''
    //   // }
    //   // if (this.form.applyTime[1] == undefined) {
    //   //   this.form.applyTime[1] = ''
    //   // }
    //   const xhr = new XMLHttpRequest();
    //   xhr.open(
    //     "post",
    //     this.baseUrl + "/api/credit/excel/expertApplyProList",
    //     true
    //   ); // get、post都可
    //   xhr.responseType = "blob"; // 转换流
    //   xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
    //   xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    //   xhr.onload = function() {
    //     if (this.status === 200) {
    //       const blob = this.response;
    //       const fileName = "已申请特色产品企业统计表.xls";
    //       if (window.navigator.msSaveOrOpenBlob) {
    //         navigator.msSaveBlob(blob, fileName);
    //       } else {
    //         const a = document.createElement("a");
    //         const url = window.URL.createObjectURL(blob);
    //         a.href = url;
    //         a.download = fileName;
    //         document.body.appendChild(a);
    //         a.click();
    //         window.URL.revokeObjectURL(url);
    //       }
    //     }
    //   };
    //   xhr.send(
    //     "name=" +
    //       this.form.name +
    //       "&uniscId=" +
    //       this.form.uniscId +
    //       "&bankCode=" +
    //       this.form.bankCode +
    //       "&startTime=" +
    //       this.form.startTime +
    //       "&endTime=" +
    //       this.form.endTime +
    //       "&pageSize=" +
    //       this.form.pageSize +
    //       "&page=" +
    //       this.form.page +
    //       "&proName=" +
    //       this.form.product
    //   );
    // }
  }
};
</script>
<style lang='less' scoped>
.content {
  min-height: 894px;
  margin-top: 10px;
  background-color: #fff;
  border-radius: 8px;
  padding-top: 10px;
  padding-bottom: 20px;
  .top {
    height: 30px;
    border-left: 8px solid #2981ee;
    padding-left: 38px;
    box-sizing: border-box;
    font-size: 22px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #2981ee;
    line-height: 30px;
  }
  .from {
    margin-top: 37px;
    margin-left: 38px;
  }
  .dowm {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-right: 40px;
    box-sizing: border-box;
    /deep/ .el-button {
      width: 157px;
      height: 40px;
      background: #2981ee;
      border-radius: 6px;
      color: #fff;
    }
  }
  .tab {
    box-sizing: border-box;
    margin-top: 15px;
    min-height: 700px;
    .block {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
    /deep/ .el-table th {
      background: #f3f4f9;
    }
  }

}
</style> 